# Adapted from http://plnkr.co/edit/T4MW49Rr3XDFjMW5gamL?p=preview
# Found here https://stackoverflow.com/questions/41833361/how-to-add-commas-in-a-input-number-field
# Modified to accept number of decimal places.
App.angularApp.directive 'mfNumber', [() =>
    require: 'ngModel',
    link: (scope, element, attrs, ngModel) =>
        attrs.$set('ngTrim', 'false')
        decimalPlaces = parseInt(attrs.mfNumber) or 0

        formatter = (str, isNum) =>
            str = String( Number(str or 0) / (if isNum then 1 else Math.pow(10, decimalPlaces)) )
            str = if str is '0' then '0.0' else str
            str = str.split('.')
            str[1] = str[1] or '0'
            return str[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + (if decimalPlaces > 0 then '.' + (str[1] + '0'.repeat(Math.max(0, decimalPlaces - str[1].length))) else '')

        updateView = (val) =>
            scope.$applyAsync () =>
                # Save cursor position
                caretPosition = element[0].selectionStart

                # Adjust position for added/removed commas
                if val.length > ngModel.$viewValue.length
                    caretPosition += 1
                else if val.length < ngModel.$viewValue.length
                    caretPosition -= 1

                # Update the view
                ngModel.$setViewValue(val or '')
                ngModel.$render()

                # Put the cursor back where it originally was
                element[0].setSelectionRange caretPosition, caretPosition

        parseNumber = (val) =>
            modelString = formatter(ngModel.$modelValue, true)
            sign =
                pos: /[+]/.test(val)
                neg: /[-]/.test(val)

            sign.has = sign.pos or sign.neg
            sign.both = sign.pos and sign.neg

            if not val or sign.has and val.length is 1 or ngModel.$modelValue and Number(val) is 0
                newVal = not val or ngModel.$modelValue and (if Number() is 0 then '' else val)
                if ngModel.$modelValue isnt newVal
                    updateView(newVal)

                return ''
            else
                valString = String(val or '')
                newSign = sign.both and ngModel.$modelValue >= 0 or not sign.both and (if sign.neg then '-' else '')
                newVal = valString.replace(/[^0-9]/g, '')
                viewVal = newSign + formatter(angular.copy(newVal))

                if modelString isnt valString
                    updateView(viewVal)

                return (Number(newSign + newVal) / Math.pow(10, decimalPlaces)) or 0

        formatNumber = (val) =>
            if (val)
                str = String(val).split('.')
                str[1] = str[1] or '0'
                val = str[0] + (if decimalPlaces > 0 then '.' + (if str[1].length is 1 then str[1] + '0' else str[1]) else '')
            return parseNumber(val)

        ngModel.$parsers.push(parseNumber)
        ngModel.$formatters.push(formatNumber)
]
